<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <div class="wombat-header-default-cell" :class="{ sortable: column.sortable, asc, desc }"
           v-on="column.tooltip ? on : undefined">
        <span v-if="column.title" @click="column.sortable && changeSortDirection()">{{ column.title }}</span>
      </div>
    </template>
    <span>{{ $t(column.tooltip) }}</span>
  </v-tooltip>
</template>

<script>
import {sortDirections} from './constants';

export default {
  name: 'WombatHeaderDefaultCell',
  props: {
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    asc() {
      return this.column.sortable && (this.column.sort || '').toLowerCase() === sortDirections.ASC;
    },
    desc() {
      return this.column.sortable && (this.column.sort || '').toLowerCase() === sortDirections.DESC;
    },
  },
  methods: {
    changeSortDirection() {
      const direction = this.column.sort || sortDirections.ASC;
      const nextSortDirection = direction === sortDirections.DESC ? sortDirections.ASC : sortDirections.DESC;
      this.$emit('columnSorted', {column: this.column, direction: nextSortDirection});
    },
  },
};
</script>

<style lang="scss" scoped>
.wombat-header-default-cell {
  display: flex;
  align-items: center;
  height: 100%;

  &.sortable {
    span {
      cursor: pointer;
    }

    span::after {
      content: '';
      display: none;
      width: 0.6em;
      height: 0.6em;
      border-top: solid 1px #999;
      border-left: solid 1px #999;
      margin-left: 0.6em;
    }

    &.asc {
      span::after {
        display: inline-block;
        transform: rotate(225deg);
        margin-bottom: 0.3em;
      }
    }

    &.desc {
      span::after {
        display: inline-block;
        transform: rotate(45deg);
      }
    }
  }
}
</style>
